import { memo } from "react";

import type { SlateRenderElementProps } from "../slateTypes";

const ThematicBreak = memo((props: SlateRenderElementProps) => {
  return (
    <hr
      className="editor-element-break"
      data-testid="thematic-break"
      {...props.attributes}
    />
  );
});

export { ThematicBreak };
